<template>
	<div>
		<div style="height: 132px;width:345px;" class="d-flex show_card">
			<div style="line-height: 130px;">
				<img :src="imgUrl" width="160" height="80">
			</div>
			<!-- 右侧描述信息 -->
			<div style="position: relative;width:185px;" class="pl-2 pt-2">
				<span class="mt-2">{{title}}</span>
				<p style="font-size: 20px;color: #C32A1A;position: absolute;bottom: 0;">{{price}}</p>
			</div>
		</div>
	</div>
</template>

<script>
	export default{
		props: {
			imgUrl:{
				type:[String,Number],
				default:''
			},
			title:{
				type:[String,Number],
				default:''
			},
			patentType:{
				type:String,
				default:''
			},
			price:{
				type:[String,Number],
				default:''
			}
		},
	}
</script>

<style scoped>
	.show_card{
		transition:box-shadow 0.5s;
		-webkit-transition:box-shadow 0.5s; 
	}
	.show_card:hover{
		box-shadow: 5px 5px 4px rgba(0, 0, 0, .12), 5px 5px 5px rgba(0, 0, 0, .04);
		position: relative;
		bottom: 5px;
	}
</style>
